import { type CaptchaProvider } from '@retailer-platform/shared-components'
import { useMemo } from 'react'
import clientEnv from '../../../utils/global/clientEnv'

export const useCaptchaProps = () =>
  useMemo(() => {
    const provider = clientEnv.PUBLIC_CLIENT_CAPTCHA_PROVIDER
    const providers: Record<
      CaptchaProvider,
      {
        sitekey: string
        provider: CaptchaProvider
        fieldName: 'turnstileToken' | 'reCaptchaToken'
      }
    > = {
      turnstile: {
        sitekey: clientEnv.PUBLIC_CLIENT_CLOUDFLARE_TURNSTILE_SITE_KEY,
        provider: 'turnstile',
        fieldName: 'turnstileToken',
      },
      recaptcha: {
        sitekey: clientEnv.PUBLIC_CLIENT_GOOGLE_RECAPTCHA_SITE_KEY,
        provider: 'recaptcha',
        fieldName: 'reCaptchaToken',
      },
    }

    return providers[provider] || providers.recaptcha
  }, [])
